import {
  Box,
  Button,
  Grid,
  InputLabel,
  SelectChangeEvent,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React, { FC } from "react";
import useResponsive from "../../hooks/useResponsive";

import { useMutation } from "@tanstack/react-query";
import SelectInput from "../UIElements/select";
import { useNavigate } from "react-router-dom";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import { PostJobProps, PostJobPropsType } from "../../interface/job_board";
import dayjs, { Dayjs } from "dayjs";
import { useNotificationService } from "../notification";
import { LoadingButton } from "@mui/lab";
import { useAuth } from "../../hooks/useAuth";

export const labelSty = {
  fontFamily: "DM Sans",
  fontSize: "12px",
  fontWeight: 500,
  lineHeight: "18px",
  letterSpacing: "-0.23999999463558197px",
  textAlign: "left",
  color: "#404E57",
  marginBottom: 1,
};
const PreviewForm: FC<{
  type: string;
  data: PostJobProps;
  date: Dayjs | null;
  documents: string[];
  salary: { min: string; max: string };
}> = ({ type, data, date, documents, salary }) => {
  const theme = useTheme();
  const {token} = useAuth()
  const { showNotification } = useNotificationService();
  const navigate = useNavigate();
  const isMedium = useResponsive("down", "md", "xl");

  const headerSty = {
    fontFamily: "Lexend",
    fontWeight: 500,
    my: isMedium ? 2 : 3,
    color: theme.palette.neutral.light,
  };

  const textSty = {
    fontFamily: "DM Sans",
    fontSize: "12px",
    fontWeight: 700,
    lineHeight: "18px",
    textAlign: "left",
  };

  const handleJobPost = () => {
    const form_data = {
      ...data,
      job_type: type,
      required_documents: documents,
      salary_range: salary,
      application_deadline: date?.toISOString(),
    };
    
    
  };
  return (
    <Box sx={{}}>
      <Stack direction={"row"} justifyContent={"space-between"}>
        <Typography sx={{ ...headerSty, my: 0, mb: 2 }} variant="subtitle2">
          Add Hospital
        </Typography>
        <LoadingButton
          onClick={handleJobPost}
          // loading={mutation.isPending}
          type="submit"
          variant="contained"
          sx={{
            borderRadius: "12px",
            fontFamily: "DM Sans",
            fontWeight: 700,
            width: 100,
          }}
        >
          Create
        </LoadingButton>
      </Stack>
      <Typography sx={{ ...headerSty, my: 2 }} variant="subtitle2">
        Hospital Type
      </Typography>
      <Box>
        <Stack direction={"row"} sx={{ gap: 2, my: 2 }}>
          <Typography sx={{ ...labelSty, mb: 0 }}>Hospital Type</Typography>
          <Typography sx={{ ...textSty }}>{type}</Typography>
        </Stack>
        <Typography sx={{ ...headerSty, my: 0 }} variant="subtitle2">
          Hospital Details
        </Typography>
        <Stack
          direction={isMedium ? "column" : "row"}
          alignItems={"center"}
          justifyContent={"space-between"}
          sx={{ my: 3, gap: 2 }}
        >
          <Stack sx={{ width: isMedium ? "100%" : "49%" }}>
            <Typography sx={{ ...labelSty, mb: 0 }}>Name</Typography>
            <Typography sx={{ ...textSty }}>{data?.job_title}</Typography>
          </Stack>
          <Stack sx={{ width: isMedium ? "100%" : "49%" }}>
            <Typography sx={{ ...labelSty, mb: 0 }}>Speciality</Typography>
            <Typography sx={{ ...textSty }}> {data?.department}</Typography>
          </Stack>
        </Stack>
        <Stack sx={{ width: "100%", my: 2 }}>
          <Typography sx={{ ...labelSty, mb: 0 }}>Hospital Description:</Typography>
          <Typography sx={{ ...textSty }}>{data?.job_description}</Typography>
        </Stack>
        <Stack
          direction={isMedium ? "column" : "row"}
          alignItems={"center"}
          justifyContent={"space-between"}
          sx={{ my: 3, gap: 2 }}
        >
          <Stack sx={{ width: isMedium ? "100%" : "49%" }}>
            <Typography sx={{ ...labelSty, mb: 0 }}>Staff Range</Typography>
            <Typography sx={{ ...textSty }}>{data?.qualifications}</Typography>
          </Stack>
          <Stack sx={{ width: isMedium ? "100%" : "49%" }}>
            <Typography sx={{ ...labelSty, mb: 0 }}>
              Bed range
            </Typography>
            <Typography sx={{ ...textSty }}>
              {data?.experience_level}
            </Typography>
          </Stack>
        </Stack>
      </Box>

      {/*  */}
      <Box>
        <Typography sx={{ ...headerSty, my: 0, mb: 2 }} variant="subtitle2">
          Work Schedule
        </Typography>
        <Stack
          direction={isMedium ? "column" : "row"}
          alignItems={"center"}
          justifyContent={"space-between"}
          sx={{ my: 3, gap: 2 }}
        >
         
          <Stack sx={{ width: isMedium ? "100%" : "49%" }}>
            <Typography sx={{ ...labelSty, mb: 0 }}>Work Schedule:</Typography>
            <Typography sx={{ ...textSty }}>{data?.work_schedule}</Typography>
          </Stack>
          <Stack sx={{ width: isMedium ? "100%" : "49%" }}>
            <Typography sx={{ ...labelSty, mb: 0 }}>
              Shifting
            </Typography>
            <Typography sx={{ ...textSty }}>{data?.employment_type}</Typography>
          </Stack>
        </Stack>
        <Stack
          direction={isMedium ? "column" : "row"}
          alignItems={"center"}
          justifyContent={"space-between"}
          sx={{ my: 3, gap: 2 }}
        >
          <Stack sx={{ width: isMedium ? "100%" : "49%" }}>
            <Typography sx={{ ...labelSty, mb: 0 }}>
              Shift amount
            </Typography>
            <Typography sx={{ ...textSty }}>
              {data?.contract_duration}
            </Typography>
          </Stack>
         
        </Stack>
      </Box>
      <Box>
        <Typography sx={{ ...headerSty, my: 0, mb: 2 }} variant="subtitle2">
          Location 
        </Typography>
        <Stack
          direction={isMedium ? "column" : "row"}
          alignItems={"center"}
          justifyContent={"space-between"}
          sx={{ my: 3, gap: 2 }}
        >
          <Stack sx={{ width: isMedium ? "100%" : "49%" }}>
            <Typography sx={{ ...labelSty, mb: 0 }}>Work Location:</Typography>
            <Typography sx={{ ...textSty }}>{data?.work_location}</Typography>
          </Stack>
         
        </Stack>
   
      </Box>
   
    </Box>
  );
};

export default PreviewForm;
